import {CallHomeRequests} from '../../../values/call-home-request'
import AppState from '../../types/app-state'

export const callHomeRequestsSelector = (state: AppState): CallHomeRequests[] =>
    state.callHomeRequests.callHomeRequests
export const isFetchingCallHomeRequestsSelector = (state: AppState): boolean =>
    state.callHomeRequests.isFetching
